import { SvgIcon, } from "@material-ui/core";
import React from "react";

const OpenInNewIcon = (props) => {

  return (
    React.createElement(SvgIcon, { ...props,}
      , React.createElement('path', { d: "M14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14ZM19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12H19V19Z"                              ,} )
    )
  )
};

export default OpenInNewIcon;